import { createContext, PropsWithChildren, useContext } from 'react';
import { PipeResponse } from '../../shared/quote-or-design-form/GetDataForQuoteOrDesignForm';
import { PdfDataManifold } from '../PdfDataResponse';

export const usePdfStaticReferenceData = () => {
  return useContext(PdfStaticReferenceDataContext);
};

const PdfStaticReferenceDataContext = createContext<{
  pipeOptions: Array<PipeResponse>;
  manifolds: Array<PdfDataManifold>;
}>({
  pipeOptions: [
    {
      code: '',
      internalCrossSectionalAreaInMetresSquared: 0,
      displayName: '',
      internalDiameterInMillimetres: 0,
      isUnderfloorHeating: false,
      waterContentInLitresPerMetre: 0,
      outsideDiameterInMillimetres: 0,
      wallThicknessInMillimetres: 0,
    },
  ],
  manifolds: [
    {
      manifoldId: 0,
      name: 'Manifold A - Kitchen',
      pumpId: null,
      flowTemperatureInDegreesCelsius: 0,
      rooms: [],
    },
  ],
});

type Props = PropsWithChildren<{ pipes: Array<PipeResponse>; manifolds: Array<PdfDataManifold> }>;

export const PdfStaticReferenceDataContextProvider = ({ pipes, manifolds, children }: Props) => {
  return (
    <PdfStaticReferenceDataContext.Provider value={{ pipeOptions: pipes, manifolds }}>
      {children}
    </PdfStaticReferenceDataContext.Provider>
  );
};
